<template>
  <div>
    <div class="box">
      <div class="box1">
        <div class="main5">
          <h3 class="main3">基础信息</h3>
          <div class="main1">
            <BBtnPrimary
              v-if="loginUserId !== rowUserId && rowUserOrgId === orgId"
              :img-src="require('@/assets/edit.png')"
              :clicked="handleEdit"
              btn-txt="编辑"
            />
          </div>
        </div>
        <div class="main">
          <div class="main1">
            <img
              :src="
                userInfo.idPhotoUrl
                  ? userInfo.idPhotoUrl
                  : require('@/assets/avatar.jpg')
              "
              width="200px"
              height="200px"
              v-on:click="selectPhoto()"
            />
            <input
              class="hidden"
              type="file"
              ref="fileselect"
              accept="image/*"
              @change="fileSelected"
            />
          </div>
          <div class="main2">
            <div class="mt-10">
              <label class="textend">姓名：</label>
              <label class="textstart">{{ userInfo.teacherName }}</label>
            </div>
            <div class="mt-20">
              <label class="textend">性别：</label>
              <label class="textstart">{{ userInfo.sex }}</label>
            </div>
            <div class="mt-20">
              <label class="textend">角色：</label>
              <label class="textstart">{{ userInfo.roleName }}</label>
            </div>
            <div class="mt-20">
              <label class="textend">身份证号：</label>
              <label class="textstart">{{ userInfo.idCardNum }}</label>
            </div>
            <div class="mt-20">
              <label class="textend">添加时间：</label>
              <label class="textstart">{{ userInfo.createTime }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="box2">
        <div>
          <div class="main4">
            <h3 class="main3">个人介绍</h3>
            <div class="main1">
              <BBtnPrimary
                :img-src="require('@/assets/edit.png')"
                :clicked="addIntroduce"
                btn-txt="编辑"
              />
            </div>
          </div>
          <div class="mt-10" v-if="userInfo.introduce">
            <b class="graytext">{{ userInfo.introduce }}</b>
          </div>
          <div class="mt-10" v-else>
            <span class="graytext">暂无个人介绍</span>
          </div>
        </div>
      </div>
    </div>
    <div class="box3">
      <div class="mt-20">
        <div class="main4">
          <h3 class="main3">资质信息</h3>
          <div class="main1">
            <BBtnPrimary
              :img-src="require('@/assets/edit.png')"
              :clicked="addQualificationUrl"
              btn-txt="编辑"
            />
          </div>
        </div>
        <div
          v-if="
            userInfo.qualificationUrl != null &&
              userInfo.qualificationUrl.length > 0
          "
        >
          <div class="inner-box">
            <div
              v-for="(item, index) in userInfo.qualificationUrl"
              :key="index"
              class="item"
            >
              <img style="width:110px;height:110px;" :src="item" />
              <img
                class="delete-img"
                src="@/assets/circle-delete.png"
                v-on:click="deleteImg(item)"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="mt-10" v-else>
          <span class="graytext">暂无资质信息</span>
        </div>
      </div>
    </div>
    <div class="box3" v-if="userInfo.roleName !== '管理员'">
      <div>
        <h3 class="boldtext">管理班级</h3>
      </div>
      <div class="table-scroll">
        <Table
          :headers="headers"
          :tableData="classList"
        >
        </Table>
      </div>
    </div>
  </div>
</template>
<script>
import {
  detail,
  saveAvatar,
  saveQualificationUrl,
  deleteQualification,
} from "@/api/teacherManagement";
import { upload } from "@/api/upload";
import Table from "../../components2/Table";
import BBtnPrimary from "../../components2/BBtnPrimary";
import Hub from "../../events/Hub";
import UploadImage from "@/views2/sample/UploadImage";
import IntroduceAdd from "@/views2/sample/IntroduceAdd";
import Vue from "vue";
import PopupContents from "../../views2/sample/PopupContents";
export default {
  components: {
    Table,
    BBtnPrimary,
  },
  data: () => ({
    loginUserId: sessionStorage.getItem('userId'),
    rowUserId: sessionStorage.getItem('rowUserId'),
    introduceDialogFlg: false,
    loading: false,
    snackbar: false,
    timeout: 3000,
    snackbarColor: "success",
    snackbarText: "",
    headers: [
      { text: "ID", value: "indexNum", sortable: false, align: "left" },
      { text: "班级", value: "className", sortable: false, align: "left" },
      { text: "学员", value: "studentNum", sortable: false, align: "left" },
    ],
    classList: [],
    userInfo: {},
    userId: 0,
    data: {},
    imgData: {},
    deleteId: 0,
    navi: [{ name: "teach-team" }, { name: "teach-team-detail" }],
    rowUserOrgId: sessionStorage.getItem("rowUserOrgId"),
    orgId: sessionStorage.getItem("orgId"),
  }),
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.userId = vm.$route.params.userId;

      // 参数赋值 班级id
      if (vm.userId !== undefined && vm.userId !== null && vm.userId !== "") {
        // 把不为空的参数存入缓存
        const params = {
          userId: vm.userId,
        };
        vm.$store.commit("SET_TEACHER_DETAIL_PARAMS", params);
      }

      // 查询条件赋值
      if (
        vm.$store.state.teachTeamDetail_userId !== undefined &&
        vm.$store.state.teachTeamDetail_userId !== null &&
        vm.$store.state.teachTeamDetail_userId !== ""
      ) {
        vm.userId = vm.$store.state.teachTeamDetail_userId;
      }

      // 页面初期化
      vm.init();
    });
  },
  destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
  beforeMount() {
    this.$store.commit("SET_NAVI_DATA", this.navi);
  },
  mounted() {
    this.$nextTick(
      function() {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
  },
  methods: {
    // 页面初期化
    async init() {
      var param = {
        id: this.userId,
      };
      const data = await detail(param);
      if (data.data.searchList != null || data.data.searchList === "") {
        this.classList = data.data.searchList;
      }
      this.userInfo = data.data;
    },
    addQualificationUrl() {
      this.imgData = this.userInfo.qualificationUrl;
      Hub.$emit("open-modal");
      Hub.$emit("set-modal-data", this.imgData, "添加资质信息", UploadImage);
    },
    addIntroduce() {
      this.data.id = this.userId;
      this.data.introduce = this.userInfo.introduce;
      Hub.$emit("open-modal");
      Hub.$emit("set-modal-data", this.data, "添加个人介绍", IntroduceAdd);
    },
    handleEdit() {
      this.$router.push({
        name: "account-add",
        params: {
          id: this.userId,
          editflg: 1,
        },
      });
    },
    selectPhoto() {
      this.$refs.fileselect.click();
    },
    fileSelected() {
      let files = this.$refs.fileselect.files;
      var msg = this.comUtils.fileUploadCheck(files[0], "img");
      if (msg.snackbarText != "") {
        Vue.prototype.$valertbar.show(msg.snackbarText);
      } else {
        if (files[0]) {
          this.upload(files);
        }
      }
    },
    async upload(files) {
      var formData = new FormData();
      formData.append("file", files[0]);
      const data = await upload(formData);
      this.saveAvatar(data[0]);
    },
    async saveAvatar(avatarUrl) {
      var param = {
        id: this.userId,
        avatarUrl: avatarUrl,
      };
      const data = await saveAvatar(param);
      if (data.code === 0) {
        this.init();
        Vue.prototype.$vsnackbar.show(data.msg);
      } else {
        Vue.prototype.$valertbar.show(data.msg);
      }
    },
    set(value) {
      if (value == 0) {
        this.init();
      }
      if (value == 1) {
        this.deleteQualification();
      }
      if (value[0]) {
        this.imgData = value;
        this.saveQualificationUrl();
      }
    },
    async saveQualificationUrl() {
      var param = {
        id: this.userInfo.id,
        qualificationUrl: this.imgData,
      };
      const data = await saveQualificationUrl(param);
      if (data.code === 0) {
        this.init();
        Vue.prototype.$vsnackbar.show(data.msg);
      } else {
        Vue.prototype.$valertbar.show(data.msg);
      }
    },
    deleteImg(item) {
      this.deleteItem = item;
      this.data.bodyText = "确认是否删除？";
      Hub.$emit("open-modal");
      Hub.$emit("set-modal-data", this.data.bodyText, "删除", PopupContents);
    },
    async deleteQualification() {
      const data = await deleteQualification(this.deleteItem);
      if (data.code === 0) {
        this.init();
        Vue.prototype.$vsnackbar.show(data.msg);
      } else {
        Vue.prototype.$valertbar.show(data.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  height: 300px;
  margin-left: 20px;
  padding-top: 30px;
}
.box1 {
  width: 50%;
  margin-right: 20px;
}
.box2 {
  width: 50%;
  margin-right: 20px;
}
.box3 {
  min-height: 200px;
  margin-left: 20px;
  margin-right: 20px;
}

.main {
  display: flex;
  margin-top: 20px;
}

.main1 {
  display: inline-block;
}

.main2 {
  display: inline-block;
  margin-left: 20px;
}

.main3 {
  display: inline-block;
  font-weight: bolder;
}

.main4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main5 {
  display: flex;
  justify-content: space-between;
}

.boldtext {
  font-weight: bolder;
}

.textend {
  font-size: 16px;
  font-weight: bold;
  text-align: end;
}

.textstart {
  font-size: 16px;
  text-align: start;
}

.mt-10 {
  margin-top: 10px;
}
.mt-20 {
  margin-top: 20px;
}

.buletext {
  color: blue;
}
.graytext {
  color: gray;
}

.grayboldtext {
  color: gray;
  font-weight: bolder;
}

.hidden {
  display: none;
}

.inner-box {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  position: relative;
  overflow: auto;
  overflow-x: hidden;
  padding-top: 5px;
  height: 141px;
}
.item {
  margin-left: 3px;
  margin-right: 3px;
  margin-top: 20px;
}

.delete-img {
  position: relative;
  width: 23px;
  height: 23px;
  left: -12px;
  bottom: 100px;
}

.table-scroll {
  margin-top: 20px;
}
</style>
